/*
 * Avatar: the user's initials, white on black, in a 32px circle (Kenno, 2026-10-03; replaces the
 * Figma gradient square). The name is the button's tooltip and the menu's first line.
 */
export function initials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean)
    const letters = parts.length > 1 ? parts[0]![0]! + parts[parts.length - 1]![0]! : (parts[0] ?? '?').slice(0, 2)
    return letters.toUpperCase()
}

export function Avatar({ name }: { name: string }) {
    return (
        <span aria-hidden className="flex size-[32px] shrink-0 items-center justify-center rounded-full bg-[var(--nav-avatar-surface)] hover:bg-[var(--nav-avatar-surface-hover)]">
            <span className="text-[13px] leading-[16px] font-semibold tracking-[0.3px] whitespace-nowrap text-[var(--nav-avatar-text)]">{initials(name)}</span>
        </span>
    )
}
